import { Dialog, DialogActions, DialogTitle } from '@mui/material';
import { PropTypes } from 'prop-types';
import { LoadingButton } from '@mui/lab';
import { useDispatch, useSelector } from 'react-redux';
import { maintenanceReturnRequest } from '../store/maintenanceActions';

ConfirmCompleteDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  maintenanceId: PropTypes.string,
};

export default function ConfirmCompleteDialog({ open, handleClose, maintenanceId }) {
  const dispatch = useDispatch();

  const { isSaving } = useSelector((state) => state.maintenanceReducer);

  const handleReturn = async () => {
    const result = await dispatch(maintenanceReturnRequest(maintenanceId));
    if (result?.ok) handleClose(true);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Are you sure maintenance is complete and ready for return?'}
        </DialogTitle>
        <DialogActions>
          <LoadingButton color="secondary" type="submit" variant="contained" onClick={() => handleClose(false)}>
            Cancel
          </LoadingButton>
          <LoadingButton color="error" loading={isSaving} onClick={handleReturn} type="submit" variant="contained">
            Proceed
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
